import { put, takeEvery, select } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'redux-first-history';
import { actionModalClose } from '../actions';

function* whatLocationChange() {
  yield takeEvery(LOCATION_CHANGE, function*() {
    const isModalOpen = yield select(s => s.modals.opened);
    if (isModalOpen) yield put(actionModalClose());
  });
}

export default [whatLocationChange];
